const externalPaths = {
  forgotPasswordUrl: '/app/user?op=lostpassword',
  helpCommunityLink: (locale) =>
    `https://recruiting-help.xing.com/hc/${
      locale == 'de' ? 'de' : 'en-us'
    }/categories/8443330280081-TalentService`,
  newChat: (xingProfilePageName) =>
    `/messenger/chats/new/${xingProfilePageName}`,
  profile: (pageName) => `/profile/${pageName}`,
  cv: (userName) => `/profile/${userName}/cv`,
  recruitingSettings: '/recruiting-settings?sc_o=profile_personal_settings_xts',
};

const internalPaths = {
  xss: '/e_recruiting_talent_service',
  briefingDetail: (briefingId) => `/briefings/${briefingId}`,
  shortlist: (briefingId) => `/briefings/${briefingId}/shortlist`,
  longlist: (briefingId) => `/briefings/${briefingId}/longlist`,
  shortlistDirect: (briefingId) => `/briefings/${briefingId}/shortlist`,
  candidateDetail: (briefingId, candidateId) =>
    `/briefings/${briefingId}/shortlist/${candidateId}`,
  briefingsDashboard: () => '/briefings',
  printShortlist: (briefingId) =>
    `/e_recruiting_talent_service/briefings/${briefingId}/shortlist/print`,
};

const paths = { ...externalPaths, ...internalPaths };

export { paths };
